F2.Apps['com_wfebrokerage_desktop_search'] = function(appConfig, appContent, root) {
	// Public Methods
	this.init = init;
	// Private Fields
    var $root = $(root);
	var topUrl = urlHelper.appendDebugParams('~/Search/Results'.resolveUrl());
    var popupUrl = window.location.href.indexOf('public') !== -1 ? urlHelper.appendDebugParams('~/public/Search/ResultsPopup'.resolveUrl()) : urlHelper.appendDebugParams('~/Search/ResultsPopup'.resolveUrl());
	var decodeUrl = urlHelper.appendDebugParams('~/Search/SearchDecode'.resolveUrl());

	// Private Methods
	function init() {
		var decodeService = new SearchApp.DecodeService(decodeUrl);

		var topWidgetControls = createTopWidgetControls();
		var topWidget = new SearchApp.Widget(
			topUrl,
			decodeService,
			topWidgetControls.$searchInput,
			topWidgetControls.$resultsContainer);
		initTopWidget(topWidgetControls, topWidget);

		var popupWidgetControls = createPopupWidgetControls();
		var popupWidget = new SearchApp.PopupWidget(
			popupUrl,
			decodeService,
			popupWidgetControls.$popupContainer,
			popupWidgetControls.$popup,
			popupWidgetControls.$popupSearchInput,
			popupWidgetControls.$popupRestulsContainer);
		initPopupWidget(popupWidgetControls, popupWidget);
		popupWidgetControls.$popupContainer.data('widget', popupWidget);

		topWidget.symbolSelected.add(symbolSelected);
		topWidget.allResultsClicked.add(allResultsClicked(topWidget, popupWidget));
		return false;
	}

	// Top Widget
	function createTopWidgetControls() {
		var $searchInput = $root.find('#search-input');
		var $searchButton = $root.find('#search-button');
		var $resultsContainer = $root.find('#results-container');
		var $roots = $()
			.add($searchInput)
			.add($searchButton)
			.add($resultsContainer);

		return {
			$searchInput: $searchInput,
			$searchButton: $searchButton,
			$resultsContainer: $resultsContainer,
			$roots: $roots
		};
	}

	function initTopWidget(controls, widget) {
		var screenHeight;

		// WF-2094: Add focusout events
		// Screen height changes when a soft keyboard is opened/closed.
		// On mobile devices, focusout fires before blur.
		// Compare screen heights during the two events to determine if results should be hidden.

		controls.$searchButton.click(widget.showSuggestions);
		controls.$searchInput.on('focus change input paste keyup', widget.showSuggestions);
		controls.$searchInput.keydown(inputKeyDownHandler(widget));

		controls.$roots.on('focus', widget.abortHide);
		controls.$roots.on('focusout', function () { screenHeight = screen.height; });
		controls.$roots.on('blur', function () {
			if (screen.height >= screenHeight) {
				widget.hideSuggestions();
			}
		});

		controls.$roots.on('focus', '*', widget.abortHide);
		controls.$roots.on('focusout', '*', function () { screenHeight = screen.height; });
		controls.$roots.on('blur', '*', function () {
			if (screen.height >= screenHeight) {
				widget.hideSuggestions();
			}
		});
	}

	// Popup Widget
	function createPopupWidgetControls() {
		var $popupContainer = $('#search-modal');
		var $popup = $popupContainer.find('.modal-dialog');
		var $popupSearchInput = $popupContainer.find('#popup-search-input');
		var $popupSearchButton = $popup.find('#popup-search-button');
		var $popupRestulsContainer = $popup.find('#popup-results-container');

		return {
			$popupContainer: $popupContainer,
			$popup: $popup,
			$popupSearchInput: $popupSearchInput,
			$popupSearchButton: $popupSearchButton,
			$popupRestulsContainer: $popupRestulsContainer
		};
	}

	function initPopupWidget(controls, widget) {
		controls.$popupSearchInput.on('change keyup input paste', widget.showSuggestions);
		controls.$popupSearchInput.keydown(inputKeyDownHandler(widget));

		controls.$popupSearchButton.click(widget.showSuggestions);
	}

	function inputKeyDownHandler(widget) {
		return function(event) {
			var isEnter = event.keyCode === 13;
			if (isEnter) {
				widget.directLookup();
			}

			// Prevent form submit
			return !isEnter;
		};
	}

	function allResultsClicked(topWidget, popupWidget) {
		return function() {
			popupWidget.symbolSelected.removeAll();
			popupWidget.symbolSelected.add(symbolSelected);

			var query = topWidget.getQuery();
			popupWidget.setQuery(query);
			popupWidget.showSuggestions();
		};
	}

	function symbolSelected (xid, data) {
		var obj = {};

		// WF-2235: Set correct easyXDM messages and values for search results symbols
		switch (data.issueType) {
			case 'Equity':
			case 'Fund':
				obj.PROFILE = xid;
				break;
			case 'Mutual Fund':
				obj.MFPROFILE = data.symbol;
				break;
			default:
				obj.FULLCHART = xid;
				break;
		}

		return MOD.WfEasyXdm.sendMessage(obj);
	}

	return false;
};
